/**
 * @class Statemachine
 * various state of the game
 *
 * game_ready
 * intro_sequence_playing
 * detailed_view
 * zoom_in_motion
 * game_preparation
 * game_is_playable
 * game_zoomed
 * game_done
 *
 */

class Statemachine {
  constructor() {
    this._state = { state: null, value: null };
  }

  set state(valueObject) {
    this._state = valueObject;
  }

  get state() {
    return this._state;
  }
}

export default new Statemachine();
